<template>
  <div>
    <el-tree style="margin-top: 20px;" :data="data" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
  </div>
</template>
<script>
export default {

  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      data: [],
    }
  },
  props: {
 
  },
  mounted() {
    this.$Http_Post('reportChartsCng/getPaperLabel', { }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.data = res.Data
      }else{
        this.Global.request_failure(res.Message);
      }
    });

  },
  methods: {
    handleNodeClick(data) {
      this.$emit('sendmsg',data)
    }
  },
  destroyed() {
    
  }
}
</script>